// components/CourseGrid.jsx
import React from 'react';
import CourseCard from './CourseCard';
import chfilogo from "../../assests/tech/chfilogo.jpg";
import Cehlogo from "../../assests/tech/Cehlogo.jpg";
import comptia from "../../assests/tech/comptia.jpg";
const courses = [
  {
    title: 'Forensic Science',
    description: 'Analyzes evidence using science to help solve crimes.',
    image: chfilogo,
  },
  {
    title: 'CEH',
    description: 'Teaches how to find and fix security gaps.',
    image: Cehlogo,
  },
  {
    title: 'CompTIA',
    description: 'Builds core and advanced IT skills.',
    image:comptia ,
  },
  // Add more courses as needed
];

const CourseGrid = () => {
  return (<>  
  <section className="Grid_section">
    <div className="course-grid">
      {courses.map((course, index) => (
        <CourseCard
          key={index}
          title={course.title}
          description={course.description}
          image={course.image}
        />
      ))}
    </div></section></>

  );
};

export default CourseGrid;
